import { AuditLogsClient } from '../clients/AuditLogsClient';
import { AuditLogsStoreState } from '@models/AuditLogsStoreState';
import { create } from 'zustand';

export const useAuditLogsStore = create<AuditLogsStoreState>((set) => ({
  auditLogs: [],
  loading: false,
  error: null,
  getAuditLogsByOrganizationId: async (organization_id, useLoading = true) => {
    if (useLoading) {
      set({ loading: true });
    }
    try {
      const auditLogs = await AuditLogsClient.getAuditLogsByOrganizationId(
        organization_id
      );
      set({ auditLogs });
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
}));
